import produce from 'immer'
import { assign } from 'lodash'

import {
  DELETE_PRIORITY_TASK_ALLOCATION,
  FETCH_ACTIVE_PRIORITY_TASKS,
  FETCH_BRANDS_WITH_NO_TOP_200_MENU,
  FETCH_PRIORITY_TASK,
  FETCH_PRIORITY_TASK_MENU_ALLOCATION_COUNTS,
  FETCH_PRIORITY_TASK_MENU_CURATION_TASKS,
  FETCH_USER_ALLOCATION_COUNTS,
  UPDATE_PRIORITY_TASK,
} from '../action-types'
import { PRIORITY_TASK_INITIAL_STATE } from '../initial-states'

const priorityTaskReducer = (state = PRIORITY_TASK_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PRIORITY_TASK.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: {},
        }),
      )

    case FETCH_PRIORITY_TASK.COMPLETE:
      return produce(state, nextState => {
        const result = action.payload.data.priorityTask

        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: result,
        })
      })

    case FETCH_PRIORITY_TASK.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: {},
        }),
      )

    case FETCH_ACTIVE_PRIORITY_TASKS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isActiveTaskLoading: true,
          error: undefined,
          activeTasks: [],
        }),
      )

    case FETCH_ACTIVE_PRIORITY_TASKS.COMPLETE:
      return produce(state, nextState => {
        const result = action.payload.data.activePriorityTasks

        assign(nextState, {
          isActiveTaskLoading: false,
          error: undefined,
          activeTasks: result,
        })
      })

    case FETCH_ACTIVE_PRIORITY_TASKS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isActiveTaskLoading: false,
          activeTaskError: action.error.message,
          activeTasks: [],
        }),
      )

    case FETCH_PRIORITY_TASK_MENU_CURATION_TASKS.START:
      return produce(state, nextState =>
        assign(nextState, {
          areMenuCurationTasksLoading: true,
          menuCurationTasksError: undefined,
          menuCurationTasks: {},
        }),
      )

    case FETCH_PRIORITY_TASK_MENU_CURATION_TASKS.COMPLETE:
      return produce(state, nextState => {
        const result = action.payload.data.priorityTaskMenuCurationTasks

        assign(nextState, {
          areMenuCurationTasksLoading: false,
          menuCurationTasksError: undefined,
          menuCurationTasks: result,
        })
      })

    case FETCH_PRIORITY_TASK_MENU_CURATION_TASKS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          areMenuCurationTasksLoading: false,
          menuCurationTasksError: action.error.message,
          menuCurationTasks: {},
        }),
      )

    case UPDATE_PRIORITY_TASK.START:
      return produce(state, nextState =>
        assign(nextState, {
          isUpdateLoading: true,
          updateError: null,
        }),
      )

    case UPDATE_PRIORITY_TASK.COMPLETE:
      return produce(state, nextState => {
        const { updatePriorityTask: priorityTask } = action.payload.data

        assign(nextState.data, priorityTask)
        assign(nextState, {
          isUpdateLoading: false,
          updateError: null,
        })
      })

    case UPDATE_PRIORITY_TASK.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isUpdateLoading: false,
          updateError: action.error.message,
        }),
      )

    case FETCH_USER_ALLOCATION_COUNTS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isUserAllocationCountsLoading: true,
          userAllocationCountsError: undefined,
          userAllocationCounts: [],
        }),
      )

    case FETCH_USER_ALLOCATION_COUNTS.COMPLETE:
      return produce(state, nextState => {
        const result = action.payload.data.userAllocationCounts

        assign(nextState, {
          isUserAllocationCountsLoading: false,
          userAllocationCountsError: undefined,
          userAllocationCounts: result,
        })
      })

    case FETCH_USER_ALLOCATION_COUNTS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isUserAllocationCountsLoading: false,
          userAllocationCountsError: action.error.message,
          userAllocationCounts: [],
        }),
      )

    case FETCH_PRIORITY_TASK_MENU_ALLOCATION_COUNTS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isPriorityTaskMenuAllocationCountsLoading: true,
          priorityTaskMenuAllocationCountsError: undefined,
          priorityTaskMenuAllocationCounts: undefined,
        }),
      )

    case FETCH_PRIORITY_TASK_MENU_ALLOCATION_COUNTS.COMPLETE:
      return produce(state, nextState => {
        const result = action.payload.data.priorityTaskMenuAllocationCounts

        assign(nextState, {
          isPriorityTaskMenuAllocationCountsLoading: false,
          priorityTaskMenuAllocationCountsError: undefined,
          priorityTaskMenuAllocationCounts: result,
        })
      })

    case FETCH_PRIORITY_TASK_MENU_ALLOCATION_COUNTS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isPriorityTaskMenuAllocationCountsLoading: false,
          priorityTaskMenuAllocationCountsError: action.error.message,
          priorityTaskMenuAllocationCounts: undefined,
        }),
      )

    case FETCH_PRIORITY_TASK.CLEANUP:
      return { ...PRIORITY_TASK_INITIAL_STATE }

    case DELETE_PRIORITY_TASK_ALLOCATION.START:
      return produce(state, nextState =>
        assign(nextState, {
          deletePriorityTaskAllocationError: undefined,
          isDeletePriorityTaskAllocationLoading: true,
        }),
      )

    case DELETE_PRIORITY_TASK_ALLOCATION.COMPLETE:
      return produce(state, nextState => {
        assign(nextState, {
          isDeletePriorityTaskAllocationLoading: false,
          deletePriorityTaskAllocationError: undefined,
        })
      })

    case DELETE_PRIORITY_TASK_ALLOCATION.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isDeletePriorityTaskAllocationLoading: false,
          deletePriorityTaskAllocationError: action.error.message,
        }),
      )

    case FETCH_BRANDS_WITH_NO_TOP_200_MENU.START:
      return produce(state, nextState =>
        assign(nextState, {
          isBrandsWithNoTop200MenuLoading: true,
          brandsWithNoTop200MenuError: undefined,
          brandsWithNoTop200Menu: [],
        }),
      )

    case FETCH_BRANDS_WITH_NO_TOP_200_MENU.COMPLETE:
      return produce(state, nextState => {
        const result = action.payload.data.brandsWithNoTop200Menu

        assign(nextState, {
          isBrandsWithNoTop200MenuLoading: false,
          brandsWithNoTop200MenuError: undefined,
          brandsWithNoTop200Menu: result,
        })
      })

    case FETCH_BRANDS_WITH_NO_TOP_200_MENU.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isBrandsWithNoTop200MenuLoading: false,
          brandsWithNoTop200MenuError: action.error.message,
          brandsWithNoTop200Menu: [],
        }),
      )

    default:
      return state
  }
}

export default priorityTaskReducer
